module.exports = __webpack_public_path__ + "img/3.e6d74fce.png";